import { fileApi } from "../index";

const FILE_ENDPOINT = "/file";

interface UploadUrlFile {
	fileName: string;
	mimeType: string;
	size: number;
}

interface SignedUploadFile {
	file_path: string;
	upload_url: string;
	upload_fields: Record<string, string>;
	mimeType: string;
	isImage: boolean;
	isVideo: boolean;
}

interface GetUploadUrlsRequest {
	files: UploadUrlFile[];
	path: string;
	MAX_IMAGE_SIZE: number;
	MAX_VIDEO_SIZE?: number;
	anonymous_token?: string;
}

interface GetUploadUrlsResponse {
	success: boolean;
	files: SignedUploadFile[];
	message?: string;
}

interface optimizedFile {
	file_path: string;
	url: string;
	isImage: boolean;
	optimized_path: string | null;
	optimized_url: string | null;
}

interface optimizeUploadRequest {
	files: { file_path: string; mimeType: string }[];
	toJPEG: string;
	toWEBP: string;
	invitationId: string;
	type: "gallery" | "memory" | "single";
	anonymous_token?: string;
	fieldName?: string;
}

interface optimizeUploadResponse {
	success: boolean;
	files: optimizedFile[];
	message?: string;
}

export const fileAPI = fileApi.injectEndpoints({
	endpoints: build => ({
		uploadFile: build.mutation<
			{ file_path: string; optimized_path: string },
			{ formData: FormData; onProgress: (pct: number) => void }
		>({
			query: ({ formData, onProgress }) => ({
				url: `${FILE_ENDPOINT}/upload`,
				method: "POST",
				body: formData,
				onUploadProgress: onProgress
			})
		}),
		uploadMultipleFiles: build.mutation<
			{ files: { file_path: string; optimized_path: string }[] },
			{ formData: FormData; onProgress: (pct: number) => void; anonymous_token?: string }
		>({
			query: ({ formData, onProgress, anonymous_token }) => ({
				url: `${FILE_ENDPOINT}/upload-multiple`,
				method: "POST",
				body: formData,
				anonymous_token,
				// onUploadProgress: e => {
				// 	console.log(e);
				// 	if (e.total) {
				// 		const pct = Math.round((e.loaded * 100) / e.total);
				// 		onProgress(pct);
				// 	}
				// },
				onUploadProgress: onProgress
			})
		}),

		getUploadUrls: build.mutation<GetUploadUrlsResponse, GetUploadUrlsRequest>({
			query: ({ files, path, MAX_IMAGE_SIZE, MAX_VIDEO_SIZE, anonymous_token }) => ({
				url: `${FILE_ENDPOINT}/get-upload-urls`,
				method: "POST",
				body: { files, path, MAX_IMAGE_SIZE, MAX_VIDEO_SIZE },
				headers: anonymous_token ? { authentication: anonymous_token } : {}
			})
		}),
		optimizeUpload: build.mutation<optimizeUploadResponse, optimizeUploadRequest>({
			query: ({ files, toJPEG, toWEBP, invitationId, type, anonymous_token, fieldName }) => ({
				url: `${FILE_ENDPOINT}/optimize-upload`,
				method: "POST",
				body: { files, toJPEG, toWEBP, invitationId, type, fieldName },
				headers: anonymous_token ? { authentication: anonymous_token } : {}
			})
		})
	})
});

export const {
	useUploadFileMutation,
	useUploadMultipleFilesMutation,
	useGetUploadUrlsMutation,
	useOptimizeUploadMutation
} = fileAPI;
